module.exports = __webpack_public_path__ + "img/contribution2.21354feb.png";